var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fold"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.unFold),expression:"unFold"}],class:[`${_vm.$appPrefix}-fold`, _vm.themeClass]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }